import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SecurityModule} from './security/security.module';
import {ReactiveFormsModule} from '@angular/forms';
import {SafeHtmlPipe} from './commons/utils/safe-html.pipe';
import {KeepHtmlPipe} from "./commons/utils/keep-html.pipe";

@NgModule({
    imports: [
        CommonModule,
        SecurityModule,
        ReactiveFormsModule
    ],
    declarations: [
        SafeHtmlPipe, KeepHtmlPipe
    ],
    providers : [
        SafeHtmlPipe, KeepHtmlPipe
    ],
    exports: [
        SafeHtmlPipe, KeepHtmlPipe
    ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts